module.exports = "<ng-template [ngIf]=\"!isLoading\">\r\n    <div class=\"view-bom-popup-container\">\r\n        <lfwms-result-data-table\r\n            [showSelectOption]=\"false\"\r\n            [searchService]=\"searchService\"\r\n            [tableMode]=\"'V'\"\r\n            [popupMode]=\"true\"\r\n            >\r\n        </lfwms-result-data-table>\r\n    </div>\r\n</ng-template>"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/components/common/view-bom-popup/view-bom-popup.component.html
// module id = ../../../../../src/app/shared/components/common/view-bom-popup/view-bom-popup.component.html
// module chunks = main